import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Calculator from "@/pages/Calculator";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App marble-bg min-h-screen">
      <BrowserRouter basename="/jewelry-repair-calculator">
        <Routes>
          <Route path="/" element={<Calculator />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
